import Loading from '../../../Common/Loading';
import { ConductAnualList } from './ConductAnualList';
import { ConductMonthList } from './ConductMonthList';
import { useDetailsChartsDataContext } from './hooks/useDetailsChartsDataContext';
import { RubricAnualList } from './RubricAnualList';
import { RubricMonthList } from './RubricMonthList';
import { PresentationAnualList } from './PresentationAnualList';
import { PresentationMonthList } from './PresentationMonthList';
import { AuthorshipAnualList } from './AutorshipAnualList';
import { AuthorshipMonthList } from './AutorshipMonthList';
import { FlagrantAnualList } from './FlagrantAnualList';
import { FlagrantMonthList } from './FlagrantMonthList';
import { InfractionalAnualList } from './InfractionalAnualList';
import { InfractionalMonthList } from './InfractionalMonthList';
import { CircumstanceAnualList } from './CircumstanceAnualList';
import { CircumstanceMonthList } from './CircumstanceMonthList';
import { UnfoldingAnualList } from './UnfoldingAnualList';
import { UnfoldingMonthList } from './UnfoldingMonthList';
import React, { useState, useCallback, memo } from 'react';
import { Button } from '@mui/material';


const RubricTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <RubricAnualList />
        <RubricMonthList />
    </div>
));

const ConductTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <ConductAnualList />
        <ConductMonthList />
    </div>
));

const PresentationTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <PresentationAnualList />
        <PresentationMonthList />
    </div>
));

const AuthorshipTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <AuthorshipAnualList />
        <AuthorshipMonthList />
    </div>
));

const FlagrantTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <FlagrantAnualList />
        <FlagrantMonthList />
    </div>
));

const InfractionalTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <InfractionalAnualList />
        <InfractionalMonthList />
    </div>
));

const CircumstanceTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <CircumstanceAnualList />
        <CircumstanceMonthList />
    </div>
));

const UnfoldingTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <UnfoldingAnualList />
        <UnfoldingMonthList />
    </div>
));

export const Charts = () => {
    const { isLoading } = useDetailsChartsDataContext();
    const [selectedTab, setSelectedTab] = useState('rubric');

    const tabs = [
        { key: 'rubric', label: 'Rúbricas' },
        { key: 'conduct', label: 'Condutas' },
        { key: 'presentation', label: 'Apresentações' },
        { key: 'authorship', label: 'Autorias' },
        { key: 'flagrant', label: 'Flagrantes' },
        { key: 'infractional', label: 'Atos Infracionais' },
        { key: 'circumstance', label: 'Circunstâncias' },
        { key: 'unfolding', label: 'Desdobramentos' }
    ];

    const handleTabChange = useCallback((key) => {
        setSelectedTab(key);
    }, []);

    const renderTabContent = useCallback(() => {
        switch (selectedTab) {
            case 'rubric':
                return <RubricTab />;
            case 'conduct':
                return <ConductTab />;
            case 'presentation':
                return <PresentationTab />;
            case 'authorship':
                return <AuthorshipTab />;
            case 'flagrant':
                return <FlagrantTab />;
            case 'infractional':
                return <InfractionalTab />;
            case 'circumstance':
                return <CircumstanceTab />;
            case 'unfolding':
                return <UnfoldingTab />;
            default:
                return null;
        }
    }, [selectedTab]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div style={{ marginBottom: 16 }}>
                {tabs.map(tab => (
                    <Button
                        key={tab.key}
                        onClick={() => handleTabChange(tab.key)}
                        style={{
                            marginRight: 8,
                            padding: '8px 16px',
                            background: selectedTab === tab.key ? '#38b2ac' : '#f0f0f0',
                            color: selectedTab === tab.key ? '#fff' : '#000',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            textTransform: 'none',
                        }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </div>
            {renderTabContent()}
        </>
    );
};
